<p-dialog
  [header]="'case.vehicle-timeline.popup-header' | translate"
  [(visible)]="showPopup"
  [modal]="true"
  (onHide)="parentPopupClose()"
  [closable]="true"
  [style]="{ width: '70%', 'max-height': '75vh', 'overflow-y': 'auto' }"
>
  <ng-container *ngIf="hasVehicles || hasUsers; else noData">
    <ng-container *ngIf="hasVehicles && hasUsers; else singlePanel">
      <p-tabView [(activeIndex)]="activeTabIndex" styleClass="timeline-tabs">
    
        <p-tabPanel [header]="'case.vehicle-timeline.vehicle' | translate" *ngIf="hasVehicles">
          <ng-container *ngTemplateOutlet="vehiclePanel"></ng-container>
        </p-tabPanel>

        <p-tabPanel [header]="'case.vehicle-timeline.staff' | translate" *ngIf="hasUsers">
          <ng-container *ngTemplateOutlet="userPanel"></ng-container>
        </p-tabPanel>
      </p-tabView>
    </ng-container>

    <ng-template #singlePanel>
      <div class="single-panel-wrap">
        <ng-container *ngIf="hasUsers; else onlyVehicles">
          <div class="single-panel-title">
            <i class="fa fa-users me-2"></i> Personel
          </div>
          <ng-container *ngTemplateOutlet="userPanel"></ng-container>
        </ng-container>

        <ng-template #onlyVehicles>
          <div class="single-panel-title">
            <i class="fa fa-truck-medical me-2"></i> Araç
          </div>
          <ng-container *ngTemplateOutlet="vehiclePanel"></ng-container>
        </ng-template>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #noData>
    <div class="text-muted">Kayıt bulunamadı.</div>
  </ng-template>

  <!-- ================== ARAÇ PANEL TEMPLATE ================== -->
  <ng-template #vehiclePanel>
    <div *ngIf="hasVehicles; else noVehicle">
      <div *ngFor="let vehicle of vehicles; let i = index">
        <div class="accordion accordion-primary-solid">
          <div class="accordion-item">
            <div
              class="accordion-header d-flex align-items-center justify-content-between"
              (click)="toggleAccordion(i)"
              [id]="'accord-' + i"
              [attr.aria-controls]="'collapse-' + i"
              [attr.aria-expanded]="expandedIndices.includes(i)"
              type="button"
              [ngClass]="{
                collapsed: !expandedIndices.includes(i),
                expanded: expandedIndices.includes(i)
              }"
            >
              <span class="accordion-header-text">
                {{ vehicle.vehicleNo }} - {{ vehicle?.dot?.dotName }}
              </span>

              <div class="d-flex align-items-center gap-2">
                <button
                  *ngIf="vehicle?.statusHistory?.length"
                  type="button"
                  class="btn btn-sm btn-warning"
                  (click)="onShowTeam(vehicle, i); $event.stopPropagation()"
                >
                  {{ "case.vehicle-timeline.show-staff" | translate }}
                </button>

                <button
                  *ngIf="vehicle?.statusHistory?.length"
                  type="button"
                  class="btn btn-sm btn-info"
                  (click)="onShowRoute(vehicle, i); $event.stopPropagation()"
                >
                  {{ "case.vehicle-timeline.show-route" | translate }}
                </button>

                <span class="ms-2">
                  {{ expandedIndices.includes(i) ? "−" : "+" }}
                </span>
              </div>
            </div>

            <div
              [id]="'collapse-' + i"
              class="accordion__body"
              [class.show]="expandedIndices.includes(i)"
              [attr.aria-labelledby]="'accord-' + i"
            >
              <div class="accordion-body-text">
                <div class="table-responsive active-projects">
                  <p-table
                    [rowHover]="true"
                    responsiveLayout="stack"
                    paginatorDropdownAppendTo="body"
                    [value]="vehicle.statusHistory"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 15%;" scope="col">
                          <span class="p-column-title">
                            {{ "case.vehicle-timeline.status-type" | translate }}
                          </span>
                        </th>
                        <th style="width: 15%;" scope="col">
                          <span class="p-column-title">
                            {{ "case.vehicle-timeline.started-at" | translate }}
                          </span>
                        </th>
                        <th style="width: 15%;" scope="col">
                          <span class="p-column-title">
                            {{ "case.vehicle-timeline.ended-at" | translate }}
                          </span>
                        </th>
                        <th style="width: 15%;" scope="col">
                          <span class="p-column-title">
                            {{ "case.vehicle-timeline.duration" | translate }}
                          </span>
                        </th>
                        <th style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{ "case.vehicle-timeline.created-at" | translate }}
                          </span>
                        </th>
                        <th style="width: 10%;" scope="col">
                          <span class="p-column-title">
                            {{ "case.vehicle-timeline.user" | translate }}
                          </span>
                        </th>
                        <th style="width: 5%;" scope="col"></th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-elem>
                      <tr>
                        <td>{{ elem?.statusName }}</td>
                        <td>{{ elem?.statusStartDate | dateFormat : true }}</td>
                        <td>{{ elem?.statusEndDate | dateFormat : true }}</td>
                        <td>{{ elem?.statusDuration }}</td>
                        <td>{{ elem?.createdAt | dateFormat : true }}</td>
                        <td>{{ elem?.createdBy ?? "-" }}</td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-warning btn-icon-xxs me-2"
                            (click)="editLogStatusDate(elem)"
                          >
                            <i class="fas fa-pencil-alt"></i>
                          </button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- end *ngFor -->
    </div>

    <ng-template #noVehicle>
      <div class="text-muted">Araç hareketi bulunamadı.</div>
    </ng-template>
  </ng-template>

  <!-- ================== PERSONEL PANEL TEMPLATE ================== -->
  <ng-template #userPanel>
    <div *ngIf="hasUsers; else noUserLogs">
      <div class="table-responsive">
        <p-table
          [rowHover]="true"
          responsiveLayout="stack"
          paginatorDropdownAppendTo="body"
          [value]="userLogs"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 30%;">Personel</th>
              <th style="width: 20%;">Durum</th>
              <th style="width: 20%;">Tarih</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-u>
            <tr>
              <td>
                <i class="fa me-2" [class]="u.icon"></i>
                {{ u.staffName }}
              </td>
              <td>{{ u.statusName ?? '-' }}</td>
              <td>{{ u.createdAt | dateFormat : true }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <ng-template #noUserLogs>
      <div class="text-muted">Personel hareketi bulunamadı.</div>
    </ng-template>
  </ng-template>
</p-dialog>

<app-vehicle-location-map
  #vehicleLocationMap
></app-vehicle-location-map>

<app-watch-team-members-card
  #teamMembers
></app-watch-team-members-card>